<template>
	<div v-if="isCommissioner">
		<h3>Draft Control</h3>
		<div v-if="!hasDraftStarted">
			Start the draft:
			<button class="start_draft base-btn" @click="start_draft">
				START THE DRAFT
			</button>
		</div>
		<div v-else>
			Reset the draft:
			<button class="restart_draft base-btn" @click="restart_draft">
				NUKE THE DRAFT
			</button>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
	computed: {
		...mapState({
			isCommissioner: state => state.user.isCommissioner,
		}),
		...mapGetters(['hasDraftStarted']),
	},
	props: {
		room_id: String,
	},
	methods: {
		start_draft() {
			this.$store.dispatch('start_draft');
		},
		restart_draft() {
			this.$store.dispatch('restart_draft');
		},
	},
};
</script>
